import React from 'react';
import { useLocation } from 'react-router-dom';
import { editClient } from '../../api';
import _ from 'lodash';

// Main Payment Page component
export default function PaymentResult() {
	const location = useLocation();
	const path = location.pathname;

    const updateClient = async () => {
        const user = JSON.parse(localStorage.getItem('phs-user'))
        const params = JSON.parse(localStorage.getItem('selectedMembership'))
        if (!user || !params) return;
        await editClient(params, user.id, '?client_select_membership=true')
        _.assign(user.profile, params.profile)
    }

    if (path.includes('/success')) {
        updateClient();
		return <PaymentStatus status="success" />;
	}

    if (path.endsWith('/cancel')) {
        return <PaymentStatus status="failure" />;
    }
	// TODO: Replace with actual payment form UI
	return <div>Payment Form Goes Here</div>;
}

function PaymentStatus({ status, message }) {
	if (status === 'success') {
		return (
			<div style={{ textAlign: 'center', padding: '40px 0' }}>
				<h2 style={{ color: '#27ae60', fontSize: 28, marginBottom: 16 }}>✅ Payment Successful!</h2>
				{message && <div style={{ color: '#444', fontSize: 16 }}>{message}</div>}
			</div>
		);
	}
	if (status === 'failure') {
		return (
			<div style={{ textAlign: 'center', padding: '40px 0' }}>
				<h2 style={{ color: '#e74c3c', fontSize: 28, marginBottom: 16 }}>❌ Payment Failed</h2>
				{message && <div style={{ color: '#444', fontSize: 16 }}>{message}</div>}
			</div>
		);
	}
	return null;
}